import {React, useState, useEffect} from 'react';

export const ShellPremiumClubReportLine = ({line}) => {
    const [rowClass, setRowClass] = useState('p-row-odd')

    const photoReportRemplate = () => {

        if(line.PhotoReport === 'Відхилено' || line.PhotoReport === 'Відсутній'){
            return ( <span style={{color:'#d20000'}}>Відсутній</span> )
        }
        else{
            return ( <span>{line.PhotoReport}</span>)
        }
    }

    const pdzTemplate = () => {
        if(line.IsPdz)
        {
            return <span style={{color:'#d20000'}}>Присутня</span>
        }
        else{
            return <span >Відсутня</span>
        }
    }
    
    const remainderTemplate = () => {
        const style = {};
        if(line.Remainder > 0){
            style.color = '#d20000';
        }
        return ( <span style={style}>{line.Remainder}</span>)
    }

    const performanceTemplate = () => {
        const percentCount = line.Performance.slice(0, -1);
        const style = {};
        if(percentCount < 100){
            style.color = '#d20000';
        }

        return(
            <span style={style}>{line.Performance}</span>
        )
    }

    const paymentsTemplate = () => {
        return ( <span> { line.Payment.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }) }  </span>)
    }

    const bonusTemplate = () => {
        if(line.IsBonus) {
            return (<span> {line.BonusAmount.toLocaleString('uk-UA', {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            })}  </span>)
        }
        else{
            const possibleBonus = Math.round(line.Payment * 0.05)
            return (<span style={{color:'#d20000'}}> {possibleBonus.toLocaleString('uk-UA', {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            })}  </span>)
        }
    }

    useEffect(() => {
        if(line.IsBonus){
            setRowClass('p-row-odd bonus-row')
        }
    }, [])


    if(line.IsDays90Debt)
    {
        return (
            <tr role="row" className={rowClass} data-p-highlight="false" data-p-highlight-contextmenu="false" data-pc-section="bodyrow">
                <td role="cell" data-p-selectable-cell="false" data-p-selection-column="false" data-p-editable-column="false" data-p-cell-editing="false" data-p-frozen-column="false" data-pc-name="datatable" data-pc-section="bodycell">
                    {line.Date}
                </td>
                <td style={{textAlign:'center'}} colSpan="8" role="cell" data-p-selectable-cell="false" data-p-selection-column="false" data-p-editable-column="false" data-p-cell-editing="false" data-p-frozen-column="false" data-pc-name="datatable" data-pc-section="bodycell">
                    Наявність незакритої відстрочки платежу (90дн). Нарахування неможливе
                </td>
            </tr>
        )
    }

    return (
        <tr role="row" className={rowClass} data-p-highlight="false" data-p-highlight-contextmenu="false" data-pc-section="bodyrow">
            <td role="cell" data-p-selectable-cell="false" data-p-selection-column="false" data-p-editable-column="false" data-p-cell-editing="false" data-p-frozen-column="false" data-pc-name="datatable" data-pc-section="bodycell">
                {line.Date}
            </td>

            <td style={{textAlign:'center'}} role="cell" data-p-selectable-cell="false" data-p-selection-column="false" data-p-editable-column="false" data-p-cell-editing="false" data-p-frozen-column="false" data-pc-name="datatable" data-pc-section="bodycell">
                {photoReportRemplate()}
            </td>

            <td style={{textAlign:'end'}} role="cell" data-p-selectable-cell="false" data-p-selection-column="false" data-p-editable-column="false" data-p-cell-editing="false" data-p-frozen-column="false" data-pc-name="datatable" data-pc-section="bodycell">
                {line.Plan}
            </td>

            <td style={{textAlign:'end'}} role="cell" data-p-selectable-cell="false" data-p-selection-column="false" data-p-editable-column="false" data-p-cell-editing="false" data-p-frozen-column="false" data-pc-name="datatable" data-pc-section="bodycell">
                {line.Fact}
            </td>

            <td style={{textAlign:'end'}} role="cell" data-p-selectable-cell="false" data-p-selection-column="false" data-p-editable-column="false" data-p-cell-editing="false" data-p-frozen-column="false" data-pc-name="datatable" data-pc-section="bodycell">
                {performanceTemplate()}
            </td>

            <td style={{textAlign:'end'}} role="cell" data-p-selectable-cell="false" data-p-selection-column="false" data-p-editable-column="false" data-p-cell-editing="false" data-p-frozen-column="false" data-pc-name="datatable" data-pc-section="bodycell">
                {remainderTemplate()}
            </td>

            <td style={{textAlign:'center'}} role="cell" data-p-selectable-cell="false" data-p-selection-column="false" data-p-editable-column="false" data-p-cell-editing="false" data-p-frozen-column="false" data-pc-name="datatable" data-pc-section="bodycell">
                {pdzTemplate()}
            </td>

            <td style={{textAlign:'end'}} role="cell" data-p-selectable-cell="false" data-p-selection-column="false" data-p-editable-column="false" data-p-cell-editing="false" data-p-frozen-column="false" data-pc-name="datatable" data-pc-section="bodycell">
                {paymentsTemplate()}
            </td>

            <td style={{textAlign:'end'}}  role="cell" data-p-selectable-cell="false" data-p-selection-column="false" data-p-editable-column="false" data-p-cell-editing="false" data-p-frozen-column="false" data-pc-name="datatable" data-pc-section="bodycell">
                {bonusTemplate()}
            </td>
        </tr>
    )
}